import React, { useContext, useEffect, useState } from 'react';
import Container from '../../v2/Container';
import TextInput from '../../TextInput';
import Button from '../../Button';
import { Package, School, Student } from '../../../models';
import { CustomerContext } from '../../../contexts/CustomerContext';
import { useHistory } from 'react-router-dom';
import routes from '../../../routes';
import useQueryString from '../../../hooks/use-query-string';
import OrderPackage from '../../../models/OrderPackage';

export function useShoobApptPricelist() {
  const [pricelist, setPricelist] = useState();

  useEffect(() => {
    Package
      .where({ shouldShowAppointments: true, schoolId: 1075 })
      .all()
      .then((res) => setPricelist(res.data[res.data.length - 1]));
  }, []);

  return pricelist;
}

export default function OtherSchoolTypeForm({ school }) {
  const { customer, setCustomer } = useContext(CustomerContext);
  const history = useHistory();
  const { p } = useQueryString();

  const pricelist = useShoobApptPricelist();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const student = new Student({ firstName, lastName, schoolId: school.id });

    student
      .save()
      .then(() => {
        const orderPackage = new OrderPackage({
          package: pricelist,
          packageId: pricelist.id,
          cartId: customer.apptCart.id,
          student,
          studentId: student.id,
          isPreviewHidden: false,
        });

        setCustomer({ ...customer, currentStudent: student, currentOrderPackage: orderPackage });
      })
      .finally(() => history.push(routes.scheduleAtShoob({
        status: 0, t: 1, s: school.id, p,
      })));
  };

  return (
    <Container maxWidth="md">
      <form onSubmit={handleSubmit}>
        <TextInput label="First Name" val={firstName} onChange={e => setFirstName(e.target.value)} />
        <div style={{ margin: '36px 0' }}>
          <TextInput label="Last Name" val={lastName} onChange={e => setLastName(e.target.value)} />
        </div>
        <Button disabled={isSubmitting} variant="submit" fullWidth>Continue</Button>
      </form>
    </Container>
  );
}
